import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import MaterialDateTimePicker from './MaterialDateTimePicker';
import './calender.css';

const Calender = (props) => {
  const {
    showYearDropdown,
    showMonthDropdown,
    selected,
    dateFormat,
    placeholderText,
    onChange,
    showTimeInput,
    timeInputLabel,
    customInput,
    readOnly,
    maxDate,
    minDate,
    minTime,
    maxTime,
    showTimeSelect,
    locale,
    timeFormat,
    timeIntervals,
    selectsRange,
    inline,
    isClearable,
    startDate,
    endDate,
    withPortal,
    shouldCloseOnScroll,
    ...rest
  } = props;

  const closeOnScroll =
    typeof shouldCloseOnScroll === 'undefined' ? false : shouldCloseOnScroll;
  const datePickerRef = useRef(null);
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const popperContainer = ({ children }) => {
    if (typeof document === 'undefined') return children;
    return createPortal(children, document.body);
  };

  useEffect(() => {
    if (!closeOnScroll) return undefined;

    const closeCalendar = () => {
      if (!isCalendarOpen) return;
      if (datePickerRef.current && typeof datePickerRef.current.setOpen === 'function') {
        datePickerRef.current.setOpen(false);
      }
      setIsCalendarOpen(false);
    };

    // Capture phase ensures we also catch scrolls from nested scroll containers.
    window.addEventListener('scroll', closeCalendar, true);
    window.addEventListener('wheel', closeCalendar, { passive: true });
    window.addEventListener('touchmove', closeCalendar, { passive: true });

    return () => {
      window.removeEventListener('scroll', closeCalendar, true);
      window.removeEventListener('wheel', closeCalendar);
      window.removeEventListener('touchmove', closeCalendar);
    };
  }, [closeOnScroll, isCalendarOpen]);

  if (showTimeSelect) {
    return (
      <MaterialDateTimePicker
        selected={selected}
        onChange={onChange}
        customInput={customInput}
        minDate={minDate}
        maxDate={maxDate}
        minTime={minTime}
        maxTime={maxTime}
        timeIntervals={timeIntervals}
        isClearable={isClearable}
        shouldCloseOnScroll={closeOnScroll}
        dateFormat={dateFormat}
      />
    );
  }

  return (
    <div className="calender">
      <DatePicker
        ref={datePickerRef}
        selected={selected}
        locale={locale}
        dateFormat={dateFormat}
        placeholderText={placeholderText}
        onChange={(e) => onChange(e)}
        showYearDropdown={showYearDropdown}
        showMonthDropdown={showMonthDropdown}
        showTimeInput={showTimeInput}
        timeInputLabel={timeInputLabel}
        readOnly={readOnly}
        customInput={customInput}
        maxDate={maxDate}
        minDate={minDate}
        minTime={minTime}
        maxTime={maxTime}
        showTimeSelect={showTimeSelect}
        timeFormat={timeFormat}
        timeIntervals={timeIntervals}
        selectsRange={selectsRange}
        inline={inline}
        isClearable={isClearable}
        startDate={startDate}
        endDate={endDate}
        withPortal={withPortal}
        closeOnScroll={closeOnScroll}
        popperPlacement="bottom-start"
        popperProps={{ strategy: 'fixed' }}
        popperContainer={popperContainer}
        calendarClassName="calender-theme"
        popperClassName="calender-popper-theme"
        popperModifiers={[
          {
            name: 'preventOverflow',
            options: {
              rootBoundary: 'viewport',
              tether: false,
            },
          },
          {
            name: 'flip',
            options: {
              fallbackPlacements: ['top-start', 'bottom-end', 'top-end'],
            },
          },
        ]}
        onCalendarOpen={() => setIsCalendarOpen(true)}
        onCalendarClose={() => setIsCalendarOpen(false)}
        {...rest}
      />
    </div>
  );
};

Calender.defaultProps = {
  id: 1,
  checked: false,
  labelTitle: 'Title',
  showYearDropdown: false,
  showMonthDropdown: false,
  showTimeInput: false,
  dateFormat: 'dd/MM/yyyy',
  placeholderText: 'To Date',
  shouldCloseOnScroll: false,
};

export default Calender;
